module.exports = __webpack_public_path__ + "static/media/logoLight.6d4c0488.webp";